import React from "react";
import Blog from "@/components/pages/Blog";
import getServer from "@/utils/functions/function";

const BlogList = ({ data, dataHeader }) => {
  return <Blog data={data} dataHeader={dataHeader} />;
};

export default BlogList;

export async function getServerSideProps(context) {
  return await getServer(context);
}
